import React from 'react'

import { Checkbox, FormControlLabel } from '@mui/material'

interface Props {
  onChange?: (checked: boolean) => void
  label?: string
}

const CheckBoxComponent: React.FC<Props> = (props: Props) => {
  return (
    <FormControlLabel control={<Checkbox onChange={(event) => props.onChange && props.onChange(event.target.checked)} />} label={props.label || ''} />
  )
}

export default CheckBoxComponent
